<div class="notepad-container">
  @if (writeAccess()) {
    <section class="header">
      <p-button
        label="{{ 'COMMERCIAL_SERVICES.LABEL.ADD_NOTE' | translate }}"
        class="p-button-raised p-button-success right-align"
        (click)="showEntryForm()"
      />
    </section>

    <p-divider />
  }

  <section class="notepad-entries">
    @for (note of notes(); track note.id) {
      <app-log-entry
        [entry]="note"
        [canEdit]="writeAccess()"
        [canDelete]="writeAccess()"
        (editEvent)="showEntryForm(note)"
        (deleteEvent)="deleteEntry(note)"
      />
    }
    @if (notes().length === 0) {
      <p>{{ 'COMMERCIAL_SERVICES.LABEL.NO_NOTES' | translate }}</p>
    }
  </section>
</div>
